var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonTaxesAndPenalties(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -904.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Taxes-and-penalties",
    transform: "translate(1206.000000, 904.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0.5 C17.3048369,0.5 18.4026997,1.309875 18.815648,2.43459375 L29.9982502,2.43459375 L29.9982502,4.36821875 L27.6005499,4.36821875 L32,13.0724375 C30.6381702,13.0724375 29.3943257,12.3206875 28.7954006,11.1349375 L25.9987502,5.603375 L23.2020997,11.1349375 C22.6041745,12.3206875 21.3593301,13.0724375 19.9975003,13.0724375 L24.3969504,4.36821875 L18.815648,4.36821875 C18.647669,4.82740625 18.3667042,5.23040625 17.99975,5.549125 L17.99975,26.6116875 L18.3767029,26.6116875 C20.8153981,26.96625 23.0631171,27.853625 24.9988751,29.1314063 L24.9988751,31.5 L7.00112486,31.5 L7.00112486,29.1314063 C8.93788276,27.853625 11.1846019,26.96625 13.6232971,26.6116875 L14.00025,26.6116875 L14.00025,5.549125 C13.6332958,5.23040625 13.3533308,4.82740625 13.184352,4.36821875 L7.60304962,4.36821875 L12.0024997,13.0724375 C10.6406699,13.0724375 9.3968254,12.3206875 8.79790026,11.1349375 L6.00124984,5.603375 L3.20459943,11.1349375 C2.60567429,12.3206875 1.36182977,13.0724375 4.08562073e-13,13.0724375 L4.39945007,4.36821875 L2.00174978,4.36821875 L2.00174978,2.43459375 L13.184352,2.43459375 C13.5973003,1.309875 14.696163,0.5 16,0.5 Z M31.9981002,15.0066438 C31.9981002,18.2112688 29.3114361,20.8084875 25.9988501,20.8084875 C22.6862642,20.8084875 19.9996,18.2112688 19.9996,15.0066438 L19.9996,15.0066438 Z M12.0005999,15.0066438 C12.0005999,18.2112688 9.31393576,20.8084875 6.00134983,20.8084875 C2.6887639,20.8084875 0.00209973753,18.2112688 0.00209973753,15.0066438 L0.00209973753,15.0066438 Z",
    id: 216
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonTaxesAndPenalties);
export default __webpack_public_path__ + "static/media/common-taxes-and-penalties.f1792288.svg";
export { ForwardRef as ReactComponent };